import { Store, useStore } from 'dg-web-shared/lib/Flux.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import * as LicensePlateState from '../state/LicensePlateState.ts';
import { Translation } from '../../common/i18n/Text.ts';
import { LicensePlateCountrySlideIn } from '../../common/components/LicensePlateCountrySlideIn.tsx';

export interface Texts {
    Heading: Translation;
    Caption: Translation;
}

export function AddLicensePlateCountrySlideIn() {
    const { storeState, update } = useStore(store => ({
        addLp: LicensePlateState.AddTripple.get(store),
    }));
    const { language } = useLanguage();

    return (
        <LicensePlateCountrySlideIn
            language={language}
            open={storeState.addLp.lpCountrySelectionOpen}
            onSelect={(v: string, formValid: boolean) =>
                update((store: Store): string => {
                    LicensePlateState.AddTripple.stateWrite(store, {
                        country: v,
                        lpCountrySelectionOpen: false,
                        formValid,
                    });
                    return 'LicensePlateCountrySlideIn-SelectLicensePlateCountry';
                })
            }
            country={storeState.addLp.country}
            licensePlateType={storeState.addLp.type}
            licensePlateNr={storeState.addLp.licensePlateNr}
            onClose={() =>
                update(store =>
                    LicensePlateState.AddTripple.stateWrite(store, {
                        lpCountrySelectionOpen: false,
                    }),
                )
            }
            outsideBody
        />
    );
}
